import { render, staticRenderFns } from "./BasicInformationAboutSubjectSearchSelect.vue?vue&type=template&id=32f16428&"
import script from "./BasicInformationAboutSubjectSearchSelect.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAboutSubjectSearchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports